import { Box, Form, Heading, Text } from '@medely/ui-kit';
import React, { useState } from 'react';
import { ContentLoader, FixedFooterLayout } from '@mp/components';
import { useGate, useMarkets } from '@mp/hooks';
import { ApplicationButtons } from '../../components/ApplicationButtons';
import { MarketsFormFields } from './components/MarketsFormFields';
import { useApplicationMutations } from '../../applicationFlowMutations';
import { useCurrentUserForMarketStep } from './graphql';
import { marketStepSchema } from './schema';
import { W2InterestBanner } from './components/w2Interest/W2InterestBanner';
import { W2InterestDialogContainer } from './components/w2Interest/W2InterestDialogContainer';
import useDialog from '@mp/hooks/useDialog';
import { gateNames } from '@mp/constants';

export const MarketsContainer = ({ isMobileVersion = false }: { isMobileVersion?: boolean }) => {
  const { isLoading, nextStepWithValues, prevStep } = useApplicationMutations();
  const { currentUser, isLoading: isCurrentUserLoading } = useCurrentUserForMarketStep();
  const { closeDialog, open, openDialog } = useDialog();
  const w2InterestGate = useGate(gateNames.w2_interest_feature);

  const [zipCode, setZipCode] = useState<string | null | undefined>();
  const isMissingW2InterestData = typeof currentUser?.professional?.w2_interest !== 'boolean';

  const { markets, isLoading: isMarketsLoading } = useMarkets({
    zipCode,
  });

  const market_ids = currentUser?.professional?.markets?.map(({ id }) => id) ?? [];

  const initialValues = { zipCode: currentUser?.address_zip, market_ids };

  const isInitialLoading = isCurrentUserLoading || isLoading;

  const handleSubmit = (values: { market_ids: number[] }) => {
    return nextStepWithValues({ professional: { market_ids: values.market_ids } });
  };

  const showW2InterestBanner = w2InterestGate && isMissingW2InterestData;

  return (
    <>
      <ContentLoader loading={isInitialLoading}>
        <>
          <Form handleSubmit={handleSubmit} schema={marketStepSchema} defaultValues={initialValues}>
            <FixedFooterLayout
              footerContent={
                <>
                  {zipCode && showW2InterestBanner && <W2InterestBanner openDialog={openDialog} />}
                  <ApplicationButtons
                    disabled={isInitialLoading}
                    backClick={() => prevStep()}
                    loading={isInitialLoading}
                  />
                </>
              }
              title={
                <>
                  <Heading
                    size="m"
                    testId="markets-title"
                    textAlign={isMobileVersion ? 'center' : 'left'}
                  >
                    Per diem shifts
                  </Heading>
                  <Box py={2}>
                    <Text size="m" testId="markets-subtitle" textAlign="justify">
                      Where are you interested in working? Select from the markets below to
                      instantly book per diem shifts.
                    </Text>
                  </Box>
                </>
              }
              height="97%"
            >
              <Box pt={isMobileVersion ? 8 : 13}>
                <MarketsFormFields
                  markets={markets}
                  onZipCodeChange={setZipCode}
                  isLoading={isMarketsLoading}
                />
                {!zipCode && showW2InterestBanner && <W2InterestBanner openDialog={openDialog} />}
              </Box>
            </FixedFooterLayout>
          </Form>
        </>
      </ContentLoader>
      <W2InterestDialogContainer open={open} onClose={closeDialog} />
    </>
  );
};
